export default function Footer() {
  return (
    <footer className="lp-footer">
      <div className="lp-footer__inner">
        <div className="lp-footer__brand">
          <div className="lp-footer__mark">
            <img src="/overmatch-logo-black.png" alt="Overmatch" />
            <span>AI</span>
          </div>
          <div className="lp-footer__tag">TURN CAPABILITY GAPS INTO FIELDED CAPABILITIES.</div>
        </div>

        <div className="lp-footer__cols">
          <div className="lp-footer__col">
            <span>PLATFORM</span>
            <a href="/#platform">Agent</a>
            <a href="/#platform">Exec</a>
            <a href="/#platform">Gateway</a>
            <a href="/#engine">Market Ledger</a>
          </div>

          <div className="lp-footer__col">
            <span>CONTACT</span>
            <a href="mailto:security@overmatchai.com">security@overmatchai.com</a>
            <a href="mailto:careers@overmatchai.com">careers@overmatchai.com</a>
          </div>

          <div className="lp-footer__col">
            <span>OVERMATCH AI, INC.</span>
            <address>
              5380 Eisenhower Ave, Suite C
              <br />
              Alexandria, VA 22304
            </address>
          </div>
        </div>
      </div>

      <div className="lp-footer__legal">
        © {new Date().getFullYear()} OVERMATCH AI, INC. ALL RIGHTS RESERVED.
      </div>
    </footer>
  )
}
